module.exports = __webpack_public_path__ + "img/right_allow.2055caff.svg";